import type { ReactElement } from 'react'
import type { TimelineEntryView, Translate } from './content-types'

/** Props for {@link ApprovalTimelineView}: the track of one localization, oldest first. */
export interface ApprovalTimelineViewProps {
	t: Translate
	entries: TimelineEntryView[]
}

const actor = (t: Translate, entry: TimelineEntryView) =>
	entry.you ? t('track.you') : entry.actorShort || t('track.system')

/** The read-only approval track as a timeline (organism). */
export function ApprovalTimelineView({ t, entries }: ApprovalTimelineViewProps): ReactElement {
	return (
		<section className="flex flex-col gap-2" aria-label={t('track.title')}>
			<h2 className="text-ds-lg font-semibold text-ds-text">{t('track.title')}</h2>
			{entries.length === 0 ? (
				<p className="text-ds-sm text-ds-text-muted">{t('track.empty')}</p>
			) : (
				<ol className="flex flex-col gap-2 border-l border-ds-border pl-4">
					{entries.map((entry) => (
						<li key={entry.id} className="flex flex-col gap-0.5 text-ds-sm">
							<span className="font-medium text-ds-text">
								{`${t(`track.actions.${entry.action}`)} · ${t(`status.${entry.fromStatus}`)} → ${t(`status.${entry.toStatus}`)}`}
							</span>
							<span>{`${actor(t, entry)} · ${entry.actorRole} · ${entry.date}`}</span>
							{entry.reason ? <span>{entry.reason}</span> : null}
							{entry.validFrom ? <span>{`${entry.validFrom} – ${entry.validTo ?? t('dates.openEnded')}`}</span> : null}
							<code className="text-ds-xs text-ds-text-muted">{entry.hash}</code>
						</li>
					))}
				</ol>
			)}
		</section>
	)
}
